import { format, parseISO } from 'date-fns';

/**
 * The app's notion of "today". `VITE_FIXED_TODAY=2026-10-23` pins it (visual tests, demos),
 * so the mock dates match the mockup screenshots.
 */
const FIXED = import.meta.env.VITE_FIXED_TODAY as string | undefined;

export function today(): Date {
  if (FIXED) {
    const d = parseISO(FIXED);
    d.setHours(12, 0, 0, 0);
    return d;
  }
  return new Date();
}

export const toISODate = (d: Date): string => format(d, 'yyyy-MM-dd');
export const fromISODate = (iso: string): Date => parseISO(iso);
